import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[80vh] md:min-h-[90vh] flex items-center pt-24 pb-12 md:pt-20 md:pb-16 overflow-hidden" data-id="element-76">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-77">
        <img src="https://cdn.magicpatterns.com/uploads/3jfJMxFR45TXDYFqSXLsHF/heylloyd-image-1772980293956.png" alt="AI Web Studio Background" className="w-full h-full object-cover object-center" data-id="element-78" />
        <div className="absolute inset-0 bg-dark/85 bg-gradient-to-b from-dark/95 via-dark/85 to-dark" data-id="element-79"></div>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-80">
        <div className="max-w-2xl mx-auto text-center" data-id="element-81">
          {/* Badge */}
          <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-82">
            <div className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-accent/15 border border-accent/30 backdrop-blur-sm mb-6 md:mb-8" data-id="element-83">
              <span className="text-base" data-id="element-84">🔥</span>
              <span className="text-accent font-semibold text-xs md:text-sm tracking-wide" data-id="element-85">
                Oferta de lanzamiento
              </span>
            </div>
          </motion.div>

          {/* Main Headline */}
          <motion.h1 className="text-[2.5rem] leading-[1.1] md:text-6xl lg:text-7xl font-extrabold text-white mb-5 md:mb-6 tracking-tight" initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.08
        }} data-id="element-86">
            Más reservas y clientes{' '}
            <span className="text-primary" data-id="element-87">para tu negocio</span>
          </motion.h1>

          {/* Subheadline */}
          <motion.p className="md:text-lg text-gray-300 mb-4 md:mb-5 max-w-xl mx-auto text-[14px]" initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.16
        }} data-id="element-88">
            Creamos webs profesionales diseñadas para atraer clientes y reservas
            automáticamente.
          </motion.p>

          {/* Trust / Value line */}
          <motion.div className="text-sm md:text-base text-gray-400 mb-8 md:mb-10 flex flex-col items-center gap-2" initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.22
        }} data-id="element-89">
            <span data-id="element-90">⭐ Pago único desde 297€</span>
            <span data-id="element-91">⭐ Web lista en 72h</span>
            <span data-id="element-92">⭐ Sin mensualidades</span>
          </motion.div>

          {/* Single CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} data-id="element-93">
            <a href="#boton-compra-297" className="inline-flex items-center justify-center gap-2.5 bg-accent hover:bg-green-600 text-white px-8 py-4 rounded-full font-bold text-lg transition-all hover:scale-[1.03] shadow-lg shadow-accent/25 active:scale-[0.98]" data-id="element-94">
              Quiero mi web
              <ArrowRightIcon className="w-5 h-5" data-id="element-95" />
            </a>
          </motion.div>

          {/* Price reinforcement */}
          <motion.p className="mt-5 text-xs md:text-sm text-gray-400" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.45
        }} data-id="element-96">
            Web profesional desde 297€ — pago único.
          </motion.p>
        </div>
      </div>
    </section>;
}